import { Circle, Path, Svg, SvgProps } from 'react-native-svg';

// Normalized to 24x24 to match Lucide sizing
const Wheel = ({ color, ...props }: SvgProps) => (
  <Svg viewBox='0 0 24 24' fill='none' {...props}>
    {/* outer, middle and center rings */}
    <Circle cx='12' cy='12' r='10' stroke={color} strokeWidth='1.5' />
    <Circle cx='12' cy='12' r='6' stroke={color} strokeWidth='1.5' />
    <Circle cx='12' cy='12' r='2' stroke={color} strokeWidth='1.5' />
    {/* spokes */}
    <Path d='M7.2 12H10.4' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <Path d='M13.6 12H16.8' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <Path d='M9.6 16.157L11.2 13.386' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <Path d='M12.8 10.614L14.4 7.843' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <Path d='M14.4 16.157L12.8 13.386' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
    <Path d='M11.2 10.614L9.6 7.843' stroke={color} strokeWidth='1.5' strokeLinecap='round' />
  </Svg>
);

export { Wheel };
